import styled from "styled-components";

const c = {
  white: "#ffffff",
  ink: "rgba(0,0,0,0.90)",
  inkSoft: "rgba(0,0,0,0.65)",
  gold: "#c9a227",
  goldSoft: "rgba(201,162,39,0.18)",
  line: "rgba(201,162,39,0.28)",
};

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  z-index: 100000;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

export const Modal = styled.div`
  position: relative;
  background: ${c.white};

  width: 100%;
  max-width: 920px;
  max-height: 90vh;

  border-radius: 28px;
  border: 1px solid rgba(201, 162, 39, 0.55);

  box-shadow:
    0 0 0 6px ${c.goldSoft},
    0 40px 120px rgba(0, 0, 0, 0.25);

  padding: 60px 70px 60px;
  overflow-y: auto;

  @media (max-width: 1024px) {
    max-width: 760px;
    padding: 50px 40px;
  }

  @media (max-width: 768px) {
    border-radius: 22px;
    padding: 40px 24px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 12px;

  width: 38px;
  height: 38px;

  border-radius: 50%;
  border: 1px solid rgba(201, 162, 39, 0.65);
  background: white;

  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  color: ${c.gold};

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.2s ease;

  &:hover {
    background: ${c.gold};
    color: white;
  }
`;

export const Title = styled.h2`
  font-family: "Cormorant Garamond", serif;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  margin-bottom: 14px;
  color: ${c.ink};
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
    letter-spacing: 0.14em;
  }
`;

export const Ornament = styled.div`
  position: relative;
  width: 240px;
  height: 14px;
  margin: 0 auto 40px;
`;

export const OrnLine = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  background: rgba(201, 162, 39, 0.55);
  transform: translateY(-50%);
`;

export const OrnDiamond = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 10px;
  height: 10px;
  background: ${c.gold};
  transform: translate(-50%, -50%) rotate(45deg);
`;

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.85;
  margin-top: 16px;
  color: ${c.inkSoft};

  strong {
    color: rgba(0, 0, 0, 0.82);
    font-weight: 700;
  }

  em {
    color: rgba(0, 0, 0, 0.62);
    font-style: italic;
  }
`;

export const List = styled.ul`
  margin: 14px 0 0;
  padding-left: 18px;
`;

export const ListItem = styled.li`
  font-size: 16px;
  line-height: 1.85;
  color: ${c.inkSoft};
  margin: 10px 0;

  strong {
    color: rgba(0, 0, 0, 0.82);
    font-weight: 700;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: ${c.line};
  margin: 34px 0;
`;
